import React from 'react'
import { Row, Col } from 'antd'
import QuickLinks from 'components/shared/QuickLinks'
import PropTypes from 'prop-types'

const renderable = (broker) => {
  const { commodity_trading: commodityTrading } = broker
  const { currency_trading: currencyTrading } = broker
  const { account_opening_process: accountOpeningProcess } = broker
  const { demat, exposure } = broker
  // If any of the option is availble then quickLInks are renderable
  // commodityTrading(For now only) || Otheroption || Another Option
  return (
    commodityTrading ||
    currencyTrading ||
    accountOpeningProcess ||
    demat ||
    exposure
  )
}

export default function BrokerQuickLinks({
  broker,
  RenderReview,
  currentPage,
}) {
  if (!broker) return null
  const {
    name,
    slug,
    commodity_trading: commodityTrading,
    currency_trading: currencyTrading,
    // eslint-disable-next-line react/prop-types
    account_opening_process: accountOpeningProcess,
    demat,
    exposure,
  } = broker
  let title = ''
  const linkList = []

  if (RenderReview || renderable(broker)) {
    title = 'Quick Links'

    if (RenderReview) {
      linkList.push({
        href: '/broker/[slug]/',
        as: `/broker/${slug}/`,
        linkText: ` ${name} Review`,
      })
    }

    if (accountOpeningProcess && currentPage !== 'AccountOpening') {
      linkList.push({
        href: '/broker/[slug]/account-opening-process',
        as: `/broker/${slug}/account-opening-process`,
        linkText: ` ${name} Account Opening Process`,
      })
    }

    if (commodityTrading && currentPage !== 'CommodityTrading') {
      linkList.push({
        href: '/broker/[slug]/commodity-trading',
        as: `/broker/${slug}/commodity-trading`,
        linkText: ` ${name} Commodity Trading`,
      })
    }
    if (currencyTrading && currentPage !== 'currencyTrading') {
      linkList.push({
        href: '/broker/[slug]/currency-trading',
        as: `/broker/${slug}/currency-trading`,
        linkText: ` ${name} Currency Trading`,
      })
    }

    if (demat && currentPage !== 'dematAccountReviewChargesOpening') {
      linkList.push({
        href: '/broker/[slug]/demat-account-review-charges-opening',
        as: `/broker/${slug}/demat-account-review-charges-opening`,
        linkText: ` ${name} Demat account review`,
      })
    }

    if (exposure && currentPage !== 'margin-exposure-leverage') {
      linkList.push({
        href: '/broker/[slug]/margin-exposure-leverage',

        as: `/broker/${slug}/margin-exposure-leverage`,

        linkText: ` ${name} Exposure`,
      })
    }

    return (
      <Row>
        <Col span={24}>
          <QuickLinks title={title} linkList={linkList} />
        </Col>
      </Row>
    )
  }

  return null
}

BrokerQuickLinks.propTypes = {
  RenderReview: PropTypes.bool,
  broker: PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    commodity_trading: PropTypes.string,
    currency_trading: PropTypes.string,
    account_opening_process: PropTypes.string,
    demat: PropTypes.string,
    exposure: PropTypes.object.isRequired,
  }).isRequired,
  currentPage: PropTypes.string,
}

BrokerQuickLinks.defaultProps = {
  RenderReview: false,
  currentPage: 'broker',
}
